Vue.component('competitors', {
	props: ['competitor_teams']
})